import baseConfig, { Config } from "../../utils/config";

// Specific configuration for Demo 3 - Electrical Mode
const demo3Config: Config = {
  ...baseConfig,
  AppName: "CADViewer: View and interact with DWG, DGN, TIFF and CALS files",
  initFileName: "/content/demo3/floorplans/1st_floor_electrical_01.dwg",
  BaseAttributes: {
    fill: "#ffd7f4", //'#D3D300', // '#ffd7f4', // '#FFF' , //  '#D3D300', // #D3D3D3  // #FFF   #ffd7f4
    "fill-opacity": 0.1, // 0.1
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  HighlightAttributes: {
    fill: "#a4d7f4",
    "fill-opacity": 0.5,
    stroke: "#a4d7f4",
    "stroke-width": 0.2,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  SelectAttributes: {
    fill: "#5BBEF6",
    "fill-opacity": 0.5,
    stroke: "#5BBEF6",
    "stroke-width": 0.23,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  postFixServerToken: false,
  // Specific configuration for electrical mode
  ShowInformativeBottomPanel: false,
  ShowInformativeLeftPanel: true,
  defaultLeftPanelOpen: false,
  displayTopPaneScrollDownButton: false, // display the top pane scroll down button, true to show the top pane scroll down menu
  DisplayCoordinatesMenu: true, // display the CADViewer coordinates menu
  displayTopNavigationBar: true, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: true, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: true, // hide the left hamburger menu
  enableRightJSONModalPanel: false, // enabling JSON load right side pane for property selection
  propertyJSONFilesEnableDistance: false,
  propertyJSONFilesEnableLayerColors: false,
  enableRightFileModalPanel: true,
  setCADViewerSkin: "dark-skin", //CADViewer Skin lightgray, black, deepblue, light-skin, dark-skin
  setBPLayerChange: false,
  serverSubFolder: "",  // demo3
  showOnlySubFolder: true, // if true, only show the serverSubFolder and its children, hide the rest of the tree  
  // zoom controls for bitmap wallpaper
  setZoomImageWallpaper: true, // set the zoom image wallpaper
  setZoomImageWallpaper_scalefactor: 1.0, // set the zoom image wallpaper scale factor , fixed at 1.0
  setZoomImageWallpaper_scalebreakpoint: 0.3, // set the zoom image wallpaper switch breakpoint
  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: true,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,


  enableAIChat: false,
  useAIChatV5: false,
  useAIChatV4: false,
  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "http://localhost:8000/process-query-v4", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "python" as "snowflake" | "python" | "snowflake-agent", // Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test" as "Test" | "Prod", // Mode for the V5 proxy endpoint (defaults to "Test")
  omitSpaceObjectLayerHandling: false
};

export default demo3Config;
